import CachedIcon from '@mui/icons-material/Cached';
import { Card, CardContent, CardHeader, CircularProgress, IconButton, Typography } from "@mui/material";
import * as React from "react";
import { SoftVersionDataModel } from "../../../models";

import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { connect } from "react-redux";
import { actionCreators, ApplicationState, FetchState, selectors } from "../../../store";
import FetchHelper from '../../FetchHelper';
import { disabledRefreshAllBtnStyle, disabledRefreshSuccessIconStyles, enableRefreshAllBtnStyle, enableRefreshSuccessIconStyles, pollingColStyle, pollingColStyleTitle } from '../../styles';

const params = {
    mainid: "",
    isRefreshAllBegin: 0,
    isRefreshAllCompleted: (status: number) => { },
    loadingRefreshAll: [false],
}
const fetchId = "SOFT_VERSION_DATA_FETCH";
const NO_OF_POLLING_TOPIC = 8;

type DemandCurrentDataProps = {
    defaultData: SoftVersionDataModel | undefined;
    isRefreshGroup: boolean;
    setRefreshGroup: (refreshGroup: boolean, name: string) => void,
    setDisabledRefreshGroupBtn: (disabled: boolean, name: string) => void,
};

export type PureDemandCurrentDataProps = DemandCurrentDataProps & ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps & typeof params;

export const SoftVersionData = (props: PureDemandCurrentDataProps) => {
    const { isRefreshAllBegin, loadingRefreshAll, defaultData, fetchState, mainid, isRefreshGroup, setRefreshGroup, setDisabledRefreshGroupBtn} = props;
    const { onError, onRefresh, isRefreshAllCompleted} = props;
    const [softVersionData, setSoftVersionData] = React.useState<SoftVersionDataModel>(props.fetchState.data);
    const [refreshFlg, setRefreshFlg] = React.useState(false);
    const [isRefreshSuccess, setIsRefreshSuccess] = React.useState(false);

    React.useEffect(() => {
        defaultData && handleFetchSuccess(defaultData, false);
        // eslint-disable-next-line
    }, [defaultData]);

    // パラメータ設定
    const handleFetchParams = () => {
        const params = new Map<string, any>();
        const code = "PQ";
        params.set("code", code);
        params.set("mainid", mainid);
        return params;
    }

    // デマンド現在値取得成功時
    const handleFetchSuccess = (data: any, isClickedRefreshBtn: boolean) => {
        setRefreshFlg(false);
        const resData = {
            mainid: data.mainid,
            version_info: data.version_info,
            lastGetDatetime: data.last_get_datetime,
        } as SoftVersionDataModel;
        setSoftVersionData(resData);
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);
        isClickedRefreshBtn && setIsRefreshSuccess(true);
    };

    const handleError = (success: boolean, data: any, error: any) => {
        setRefreshFlg(false);
        onError(success, data, error);
        if (isRefreshAllBegin > 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);
        setIsRefreshSuccess(false);
    }

    const handleRefresh = () => {
        setRefreshFlg(true);
        setIsRefreshSuccess(false);
        const params = handleFetchParams();
        onRefresh(params);
    };

    const handleRefreshSuccess = (data: any) => {
        handleFetchSuccess(data, true);
        if (isRefreshAllBegin !== 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
    }

    const refreshAll = () => {
        if (isRefreshAllBegin === NO_OF_POLLING_TOPIC) {
            console.log("fetch No:______" + isRefreshAllBegin);
            handleRefresh();
        }
        if (isRefreshGroup) {
            handleRefresh();
            setIsRefreshSuccess(false);
        }
        if (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) {
            setIsRefreshSuccess(false);
        }
        isRefreshAllBegin > 0 || isRefreshGroup ? setRefreshFlg(true) : setRefreshFlg(false);
    }

    React.useEffect(() => {
        setDisabledRefreshGroupBtn(refreshFlg, fetchId);
        // eslint-disable-next-line
    }, [refreshFlg]);

    React.useEffect(refreshAll, [isRefreshAllBegin, isRefreshGroup]);

    return (
        <>
            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            <IconButton aria-label="refresh" onClick={handleRefresh} disabled={refreshFlg}>
                                <CachedIcon fontSize="medium" style={refreshFlg ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title='SoftVersion情報'
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0' }}>
                    {(fetchState.loading || loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className={'polling'} style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={pollingColStyleTitle}>Version情報</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className={'polling'} style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={pollingColStyleTitle}>Version情報</td>
                                    <td style={pollingColStyle}>{softVersionData?.version_info}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{softVersionData?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >
            <FetchHelper fetchId={fetchId} onComplete={(success, data, error) => success ? handleRefreshSuccess(data) : handleError(success, data, error)} />
        </>
    );
};
const mapStateToProps = (state: ApplicationState) => ({
    fetchState: selectors.getFetchState(
        state,
        fetchId
    ) as FetchState,
});
const mapDispatchToProps = {
    onRefresh: (params: any) => actionCreators.fetch(fetchId, `/polling-udp/get`, "GET", params),
    onError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: "デマンド現在値取得",
            body: "デマンド現在値取得できません。",
        }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SoftVersionData);


